import styled from "styled-components"

export const Body = styled.main`
  margin: 16px 1.25rem;
  padding: 1rem;
  border: 1px solid var(--reeler-grey-dark);
  background: var(--reeler-white);
`
